type ErrorUIProps = {
  parentClassName?: string;
  labelClassName?: string;
};

/*
 * エラー発生UI
 */
export default function ErrorUI({
  parentClassName = "min-h-screen",
  labelClassName = "ml-3",
}: ErrorUIProps) {
  return (
    <div className={`flex items-center justify-center text-center ${parentClassName}`}>
      <p
        className={`font-bold text-PINK_1 ${labelClassName} rounded border-4 border-PINK_1 bg-WHITE_1 px-5 py-4 lg:px-20`}
      >
        エラーが発生しました。
        <br />
        時間をおいて再度お試しください。
      </p>
    </div>
  );
}
